import { OktaAuth } from '@okta/okta-auth-js';
import React from 'react';
import { Idp, IdpType } from 'api/account';
import { ReactComponent as Google } from 'components/atoms/vendor-loign/google.svg';
import { Button } from 'components/facade/button';
import { useTranslate } from 'hooks/use-translation';

export const SsoSamlButton = ({
  idp,
  googleSSOHandler,
  samlFlowHandler,
  isCognitoEnabled,
  oktaAuth,
  idpId,
}: {
  idp: Idp;
  googleSSOHandler: () => void;
  samlFlowHandler: () => Promise<void>;
  isCognitoEnabled: boolean;
  oktaAuth?: OktaAuth;
  idpId: string;
}) => {
  const translate = useTranslate();

  return (
    <Button
      key={idp.idpId}
      icon={idp.idpType === IdpType.Google && <Google />}
      onClick={() => {
        if (isCognitoEnabled) {
          if (idp.idpType === IdpType.Google) {
            googleSSOHandler();
          } else {
            samlFlowHandler();
          }

          return;
        }
        if (!oktaAuth) {
          return;
        }
        oktaAuth.signInWithRedirect({
          idp: idpId,
        });
      }}
    >
      {idp.idpType === IdpType.Google
        ? translate('google.sign-in')
        : translate('sign_in.sso')}
    </Button>
  );
};
